import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as _ from "lodash";
import styles from "./styles.scss";
import mainTitleStyles from "components/Title/MainTitle/styles.scss";

import Header from "components/Layout/Header";
import * as SVG from "components/SVG";

import MainTitle from "components/Title/MainTitle";
import SubTitle from "components/Title/SubTitle";
import Button from "components/Button";
import Modal01 from "components/Modal/Modal01";
import Document from "components/Document";
import ButtonBar from "components/ButtonBar"

const MidEnrollmentTerms = (props) => {
    const { data } = useSelector(state => state.contract);
    const coreManualDocsList = useSelector(state => state.contract.coreManualDocsList);
    const [btndisabled, setBtndisabled] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);

    const [openPDF, setOpenPDF] = useState(-1);

    const [checkDoc, setCheckDoc] = useState([]);

    useEffect(() => {
        window.addEventListener("beforeunload", function(e) {
            e.preventDefault();
            e.returnValue = "변경사항은 저장되지 않습니다";
        });
        if (!data) {
            props.history.push("/auth/contractNum");
        };
    }, []);

    useEffect(() => {
        if (coreManualDocsList.length === checkDoc.length) {
            setBtndisabled(false);
        }
    }, [checkDoc])

    const handleOnClickBtnSubmit = async () => {
        if (btndisabled) {
            setModalOpen(true);
        } else {
            props.history.push("/mid/signStep");
        }
    };

    const handleCheckManual = id => {
        let _checkManual = _.cloneDeep(checkDoc);
        if (!_checkManual.includes(id)) {
            _checkManual.push(id);
        }
        setCheckDoc(_checkManual);
    };

    return (
        <>
            <Header onClick={() => props.history.push("/")}/>
            <div className={styles.contentBoardWrap}>
                <div className={styles.contentBoard}>
                    <div className={styles.innerWrap}>
                        <MainTitle mainTitle="서비스 확인">
                            <p className={mainTitleStyles.brNone}>
                                변경된 서비스 상품 정보를 확인하신 후, 전자 서명을 통해 변경 사항에 동의하실 수 있습니다.<br/>
                                서비스 변경에 대한 동의는 전자 서명 완료 시 적용됩니다.
                            </p>
                        </MainTitle>

                        <div className={styles.contBox}>
                            <div className={styles.termsWrap}>
                                <SubTitle title="부속 서류 확인" isSpecial descYn="N" styles={{ borderBottom: "1px solid #cccccc" }} />
                                {coreManualDocsList?.map(docs => {
                                    return (
                                        <div
                                            className={styles.row}
                                            onClick={() => {
                                                setOpenPDF(docs?.id);
                                                handleCheckManual(docs?.id);
                                            }}
                                        >   
                                            <div className={styles.left}>
                                                <SVG.Check checked={docs?.id && checkDoc.includes(docs?.id)} />
                                                <div className={styles.title}>
                                                    {docs?.name}
                                                </div>
                                            </div>
                                            <div className={styles.svg}>
                                                보기
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <Button text={"확인"} style={{ width: "100%" }} disabled={btndisabled}
                                    onClick={handleOnClickBtnSubmit}/>
                        </div>
                    </div>
                </div>
            </div>
            {openPDF > -1 && (
                <div className={styles.pdfPopup}>
                    <Document sign={false} type={"keyPoint"} document={openPDF} />
                    <ButtonBar
                        isActive={true}
                        leftBtnTxt={"닫기"}
                        leftBtnFunc={() => setOpenPDF(-1)}
                        rightBtnTxt={"확인"}
                        rightBtnFunc={() => setOpenPDF(-1)}
                    />
                </div>
            )}
            <Modal01 open={modalOpen} close={() => setModalOpen(false)} header="안내">
                다음 단계로 넘어가기 위해서는<br/>
                변경된 서비스 상품 정보의 확인이 필요합니다.
            </Modal01>
        </>
    )

}

export default MidEnrollmentTerms;

